import { useState } from 'react';


const setUrlParam = <T>(key: string, value: T) => {
    const urlParams = new URLSearchParams(window.location.search);
    if (value == null) {
        urlParams.delete(key);
    } else {
        urlParams.set(key, value.toString());
    }
    const newRelativePathQuery = window.location.pathname + '?' + urlParams.toString();
    window.history.pushState(null, '', newRelativePathQuery);
}

export default function useQueryState<T>(QueryKey: string, DefaultValue?: T): [T, (newValue: T) => void] {
    const urlParams = new URLSearchParams(window.location.search);
    const [value, set] = useState<T>((urlParams.get(QueryKey) || DefaultValue) as T);

    const setValue = (newValue: T) => {
        set(newValue);
        setUrlParam(QueryKey, newValue);
    }

    return [value, setValue];
}